module.exports = __webpack_public_path__ + "img/icon-training-videos.add8d4d1.svg";